import { render } from "./Affectation.vue?vue&type=template&id=3a872fcb&ts=true"
import script from "./Affectation.vue?vue&type=script&lang=ts"
export * from "./Affectation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__